module.exports = __webpack_public_path__ + "static/media/timelapse_29.d03c177c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_29.jpg
// module id = 987
// module chunks = 0